import { EStripeSubStatus } from '../../../models/consts';
import { IChatgptUser, ITrialDataAPI } from '../../../models/models';
import { EClaudePlanNames, claudePlans } from '../../../models/paymentPlans/claude-payments-plan';
import { trialDaysFinishDate } from '../../../utils/trialDaysLeft';
import {
  chatgptConvAdapterFunc,
  chatgptUserAdapterFunction,
  gitlabRepoAdapterFunc,
  gitlabUserAdapterFunction
} from '../../functions';
import {EGithubPlanNames} from "../../../models/paymentPlans/github-payments-plan";

export const fetchClaudeUsersAction = (state, { payload }) => {
  if (payload) {
    state.claude.usersLoading = false;
    state.claude.users = chatgptUserAdapterFunction(payload.profiles);
  }
};

export const addClaudeUserAction = (state, { payload }) => {
  if (payload) {
    state.claude.users = gitlabUserAdapterFunction([payload] as Array<IChatgptUser>);
  }
};

export const fetchItemsForClaudeUserAction = (state, { payload }) => {
  if (payload) {
    state.claude.itemsLoading = false;
    state.claude.items = chatgptConvAdapterFunc(payload.conversations || []);
    state.claude.canUserBackup = payload.canUserBackup
    state.claude.totalItems = payload.totalCount || 0
    state.claude.limits = payload.limits || []
  }
};

export const addClaudeItemsAction = (state, { payload }) => {
  state.claude.items?.push(...gitlabRepoAdapterFunc(payload));
}

export const deleteClaudeItemAction = (state, { meta }) => {
  if (state?.claude.items && meta.arg) {
    state.claude.items = [...state.claude.items]?.filter(x => x.id !== meta.arg);
  }
}

export const checkClaudeTrialStatusAction = (state, { payload }) => {
  if (payload) {
    state.claude.isConnectionActive = !!payload.isConnectionActive

    const trialData = payload as ITrialDataAPI;
    state.claude.trial = {
      trialStatus: trialData.trialStatus,
      finishDate: trialDaysFinishDate(trialData.trialHoursLeft),
      trialHoursLeft: trialData.trialHoursLeft,
      availableItemsQuantity: trialData.availableItemsQuantity,
      addedItemsQuantity: trialData.addedItemsQuantity,
      planQuantity: trialData.trialDefaultQuantity,
      isInvoiceRequested: trialData.stripe_claude_subscription_bank_transfer_requested || false,
      isCancel: false
    };

    const { s3_region, cloud_storages, stripe_claude_next_invoice, subscription_type, subscription_period, stripe_claude_subscription_cancel_at_period_end, stripe_claude_conversations_quantity, stripe_claude_subscription_status, availableItemsQuantity, addedItemsQuantity, stripe_claude_subscription_bank_transfer_requested, stripe_claude_subscription_current_period_end } = trialData;

    state.claude.storage = cloud_storages || []
    if (s3_region) {
      state.claude.regionS3 = s3_region
    }

    if (stripe_claude_subscription_status && stripe_claude_conversations_quantity) {
      const planData = claudePlans.find(({ name }) => name === EClaudePlanNames.ESSENTIAL);
      const isAnnual = subscription_period && subscription_period === 'year' || planData?.stripeIds.yearly === trialData.stripe_claude_price_id;

      const cost = stripe_claude_next_invoice ? stripe_claude_next_invoice / 100 : 0;

      state.claude.subscription = {
        status: stripe_claude_subscription_status.toLowerCase() as EStripeSubStatus,
        planName: subscription_type === 'pro_plan' ? EGithubPlanNames.PRO : EGithubPlanNames.ESSENTIAL,
        isAnnual,
        finishDate: stripe_claude_subscription_current_period_end ? new Date(Number(stripe_claude_subscription_current_period_end + '000')).toLocaleDateString() : null,
        finishDateInMillisecond: Number(stripe_claude_subscription_current_period_end +'000' ),
        cost,
        quantity: availableItemsQuantity,
        addedItemsQuantity: addedItemsQuantity,
        planQuantity: stripe_claude_conversations_quantity,
        isInvoiceRequested: stripe_claude_subscription_bank_transfer_requested || false,
        isCancel: stripe_claude_subscription_cancel_at_period_end || false
      };
    } else if (stripe_claude_subscription_status) {
      state.claude.subscription = {
        status: stripe_claude_subscription_status.toLowerCase() as EStripeSubStatus,
        // planName: EClaudePlanNames.ESSENTIAL,
        // isAnnual:
        // finishDate: stripe_claude_subscription_current_period_end ? new Date(Number(stripe_claude_subscription_current_period_end + '000')).toLocaleDateString() : null,
        cost: 0,
        addedItemsQuantity: addedItemsQuantity,
        // quantity: availableItemsQuantity,
        // planQuantity: stripe_claude_projects_quantity,
        // isInvoiceRequested: stripe_claude_subscription_bank_transfer_requested || false,
        // isCancel: stripe_claude_subscription_cancel_at_period_end || false
      };
    }
  }
}


